import React, { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import undraw_fpass from "./undraw_fpass.png";
const axios = require("axios");
const constants = require("../constant");

function ForgotPass() {
    const [userEmail, setuserEmail] = useState("");
    const [otp, setotp] = useState("");
    const [otpPage, setotpPage] = useState(false);
    const [passChange, setpassChange] = useState(false);
    const [newPassword, setnewPassword] = useState("");
    const [confirmPassword, setconfirmPassword] = useState("");
    useEffect(() => {}, [otpPage]);
    return (
        <div>
            <Navbar />
            <div className="login-wrap d-flex align-items-center flex-wrap justify-content-center">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <img src={undraw_fpass} alt="" />
                        </div>
                        <div className="col-md-6">
                            <div className="login-box bg-white box-shadow border-radius-10">
                                <div className="login-title">
                                    {!passChange ? (
                                        <h2 className="text-center text-primary">
                                            Forgot Password
                                        </h2>
                                    ) : (
                                        <h2 className="text-center text-primary">
                                            Change Password
                                        </h2>
                                    )}
                                </div>
                                {!passChange ? (
                                    <>
                                        <h6 className="mb-20">
                                            {otpPage
                                                ? "Enter the OTP sent to your Mail!"
                                                : "Enter your email address to reset your password"}
                                        </h6>
                                        <form>
                                            <div className="input-group custom">
                                                {otpPage ? (
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-lg"
                                                        placeholder="OTP"
                                                        value={otp}
                                                        onChange={(e) =>
                                                            setotp(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                ) : (
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-lg"
                                                        placeholder="Email"
                                                        value={userEmail}
                                                        onChange={(e) =>
                                                            setuserEmail(
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                )}
                                                <div className="input-group-append custom">
                                                    <span className="input-group-text">
                                                        <i
                                                            className="fa fa-envelope-o"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="row align-items-center">
                                                <div className="col-5">
                                                    <div className="input-group mb-0">
                                                        <button
                                                            className="btn btn-primary btn-lg btn-block"
                                                            onClick={async (
                                                                e
                                                            ) => {
                                                                e.preventDefault();
                                                                if (!otpPage) {
                                                                    const result =
                                                                        await axios(
                                                                            {
                                                                                method: "post",
                                                                                url: `${constants.backendUrl}/forgotPassword`,
                                                                                data: {
                                                                                    email: userEmail,
                                                                                },
                                                                            }
                                                                        );
                                                                    console.log(
                                                                        result
                                                                    );
                                                                    if (
                                                                        result
                                                                            .data
                                                                            .success
                                                                    ) {
                                                                        alert(
                                                                            "Password reset link sent to your email"
                                                                        );
                                                                        console.log(
                                                                            result.data
                                                                        );
                                                                        setotpPage(
                                                                            true
                                                                        );
                                                                    } else {
                                                                        alert(
                                                                            result
                                                                                .data
                                                                                .message
                                                                        );
                                                                    }
                                                                } else {
                                                                    const result =
                                                                        await axios(
                                                                            {
                                                                                method: "post",
                                                                                url: `${constants.backendUrl}/verifyOTP`,
                                                                                data: {
                                                                                    email: userEmail,
                                                                                    otp: otp,
                                                                                },
                                                                            }
                                                                        );
                                                                    console.log(
                                                                        result
                                                                    );
                                                                    if (
                                                                        result
                                                                            .data
                                                                            .success
                                                                    ) {
                                                                        alert(
                                                                            "OTP verfied successfully"
                                                                        );
                                                                        console.log(
                                                                            result.data
                                                                        );
                                                                        setpassChange(
                                                                            true
                                                                        );
                                                                        setotp(
                                                                            ""
                                                                        );
                                                                        setotpPage(
                                                                            false
                                                                        );
                                                                    } else {
                                                                        alert(
                                                                            result
                                                                                .data
                                                                                .message
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-2">
                                                    <div
                                                        className="font-16 weight-600 text-center"
                                                        data-color="#707373"
                                                        style={{
                                                            color: "rgb(112, 115, 115)",
                                                        }}
                                                    >
                                                        OR
                                                    </div>
                                                </div>
                                                <div className="col-5">
                                                    <div className="input-group mb-0">
                                                        <a
                                                            className="btn btn-outline-primary btn-lg btn-block"
                                                            href="/"
                                                        >
                                                            Login
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </>
                                ) : (
                                    <>
                                        <h6 className="mb-20">
                                            Enter the New passwords
                                        </h6>
                                        <form>
                                            <div className="input-group custom">
                                                <input
                                                    type="password"
                                                    className="form-control form-control-lg"
                                                    placeholder="New Password"
                                                    value={newPassword}
                                                    onChange={(e) =>
                                                        setnewPassword(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                <br />
                                                <input
                                                    type="password"
                                                    className="form-control form-control-lg"
                                                    placeholder="Confirm Password"
                                                    value={confirmPassword}
                                                    onChange={(e) =>
                                                        setconfirmPassword(
                                                            e.target.value
                                                        )
                                                    }
                                                />
                                                <div className="input-group-append custom">
                                                    <span className="input-group-text">
                                                        <i
                                                            className="fa fa-envelope-o"
                                                            aria-hidden="true"
                                                        />
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="row align-items-center">
                                                <div className="col-5">
                                                    <div className="input-group mb-0">
                                                        <button
                                                            className="btn btn-primary btn-lg btn-block"
                                                            onClick={async (
                                                                e
                                                            ) => {
                                                                e.preventDefault();
                                                                if (
                                                                    newPassword !==
                                                                    confirmPassword
                                                                ) {
                                                                    alert(
                                                                        "Passwords do not match"
                                                                    );
                                                                    return;
                                                                } else {
                                                                    const result =
                                                                        await axios(
                                                                            {
                                                                                method: "post",
                                                                                url: `${constants.backendUrl}/changePassword`,
                                                                                data: {
                                                                                    email: userEmail,
                                                                                    password:
                                                                                        newPassword,
                                                                                },
                                                                            }
                                                                        );
                                                                    console.log(
                                                                        result
                                                                    );
                                                                    if (
                                                                        result
                                                                            .data
                                                                            .success
                                                                    ) {
                                                                        alert(
                                                                            "Password changed successfully"
                                                                        );
                                                                        window.location.href =
                                                                            "/";
                                                                    } else {
                                                                        alert(
                                                                            result
                                                                                .data
                                                                                .message
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-2">
                                                    <div
                                                        className="font-16 weight-600 text-center"
                                                        data-color="#707373"
                                                        style={{
                                                            color: "rgb(112, 115, 115)",
                                                        }}
                                                    >
                                                        OR
                                                    </div>
                                                </div>
                                                <div className="col-5">
                                                    <div className="input-group mb-0">
                                                        <a
                                                            className="btn btn-outline-primary btn-lg btn-block"
                                                            href="/"
                                                        >
                                                            Login
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPass;
